import { authClient } from "@/lib/auth-client";
import { getCurrentOrgId } from "@/lib/org-context";

function requireOrgId(): string {
  const id = getCurrentOrgId();
  if (!id) throw new Error("No active org — cannot call BA organization endpoint");
  return id;
}

export const baOrg = {
  createTeam(input: { name: string }) {
    return authClient.organization.createTeam({
      ...input,
      organizationId: requireOrgId(),
    });
  },
  updateTeam(input: { teamId: string; data: { name: string } }) {
    return authClient.organization.updateTeam({
      teamId: input.teamId,
      data: { ...input.data, organizationId: requireOrgId() },
    });
  },
  removeTeam(input: { teamId: string }) {
    return authClient.organization.removeTeam({
      ...input,
      organizationId: requireOrgId(),
    });
  },
  addTeamMember(input: { teamId: string; userId: string }) {
    return authClient.organization.addTeamMember({
      ...input,
      organizationId: requireOrgId(),
    });
  },
};
